import { FC, useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getChildren, resetLoading } from "app/features/reportsSlice";
import withAuth from "lib/hoc/withAuth";
import TableLayout from "components/Forms/TableLayout/TableLayout";
import Filters from "./components/Filters";
import Table from "./components/Table";
import { childrenColumns, childrenFileColumns } from "./components/columns";
import { DatasheetReport } from "types";
import { childrenGridMapper } from "lib/helpers/reportsHelper";
import { exportToXLSX } from "lib/helpers/convertToXLS";

const Children: FC = () => {
  const dispatch = useAppDispatch();
  const { children, loading } = useAppSelector((state) => state.reports);
  const [loadingFile, setLoadingFile] = useState(false);
  const handleSelect = (payload: DatasheetReport) => {
    dispatch(getChildren(payload));
  };

  useEffect(() => {
    dispatch(resetLoading());
  }, []);

  function handleExportFile() {
    setLoadingFile(true);
    setTimeout(() => {
      const data = childrenGridMapper(children);
      const filename = "Hijos.xlsx";
      exportToXLSX(data, childrenFileColumns, filename);
      setLoadingFile(false);
    }, 1000);
  }

  return (
    <TableLayout maxWidthCard={1600} maxWidthContainer='xl' title='Hijos'>
      <Filters
        isLoading={loading}
        loadingFile={loadingFile}
        handleSelect={handleSelect}
        handleExportFile={handleExportFile}
        isButtonEnabled={!children?.length}
      />
      <Table
        isLoading={loading}
        dataGridColumns={childrenColumns}
        rows={childrenGridMapper(children)}
        fileName='hijos'
      />
    </TableLayout>
  );
};

export default withAuth(Children);
